import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import { SERIES_COLORS } from "./palette";

export interface FunnelStep { key: string; label: string; count: number; value?: number | null; note?: string }
export type FunnelBarsProps = { steps: FunnelStep[]; valueFormatter?: (v: number) => string; onStepClick?: (key: string) => void; ariaLabel: string };

const nf = new Intl.NumberFormat("pt-BR");
const pf = new Intl.NumberFormat("pt-BR", { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 });
const TRACK = "#eef1f4";
const FIRST_STEP = "#b7c3cc";

// "Funil do período" (final-g1-conversao.png): todos os degraus na mesma escala; % sobre o degrau anterior. MUI puro.
export function FunnelBars({ steps, valueFormatter, onStepClick, ariaLabel }: FunnelBarsProps) {
  const max = Math.max(1, ...steps.map((s) => s.count));
  return (
    <Box role="group" aria-label={ariaLabel} sx={{ display: "grid", gap: "10px" }}>
      {steps.map((s, i) => {
        const prev = i > 0 ? steps[i - 1].count : null;
        const ratio = prev ? s.count / prev : null;
        return (
          <ButtonBase key={s.key} aria-label={`${s.label} ${nf.format(s.count)}`} onClick={() => onStepClick?.(s.key)} disabled={!onStepClick}
            sx={{ display: "grid", gridTemplateColumns: "minmax(110px, 180px) 1fr auto minmax(64px, auto)", alignItems: "start", textAlign: "left", gap: "8px", borderRadius: "4px", "&.Mui-disabled": { color: "inherit" } }}>
            <Typography variant="body2" fontWeight={500}>{s.label}</Typography>
            <Box>
              <Box sx={{ height: "14px", bgcolor: TRACK, borderRadius: "3px" }}>
                <Box sx={{ height: "14px", bgcolor: i === 0 ? FIRST_STEP : SERIES_COLORS[0], width: `${(s.count / max) * 100}%`, borderRadius: "3px" }} />
              </Box>
              {i > 0 && <Typography variant="caption" color="text.secondary">{`↳ ${ratio === null ? "—" : pf.format(ratio)} do degrau anterior`}</Typography>}
              {s.note && <Typography variant="caption" color="text.secondary" display="block">{s.note}</Typography>}
            </Box>
            <Typography variant="body2" fontWeight={600} align="right" sx={{ textDecoration: onStepClick ? "underline dashed" : "none" }}>{nf.format(s.count)}</Typography>
            <Typography variant="body2" color="text.secondary" align="right">{s.value != null && valueFormatter ? valueFormatter(s.value) : ""}</Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
}
